import { motion } from "framer-motion";
import { GraduationCap, ChefHat, Briefcase, Sprout, Check } from "lucide-react";
import { Reveal } from "../landing/Reveal";

const TYPES = [
  {
    icon: GraduationCap,
    name: "Student",
    grad: "from-[#635BFF] to-[#8B85FF]",
    perks: ["Learn Skills", "Find Jobs", "Make Friends", "Earn Money", "Join Communities"],
  },
  {
    icon: ChefHat,
    name: "Student Chef",
    grad: "from-[#FF7A00] to-[#FFB25E]",
    perks: ["List Recipes", "Rent Kitchens", "Manage Inventory", "Increase Sales"],
  },
  {
    icon: Briefcase,
    name: "Recruiter",
    grad: "from-[#00D26A] to-[#4ADE80]",
    perks: ["Post Jobs", "Track Candidates", "Manage Referrals", "Conduct Interviews"],
  },
  {
    icon: Sprout,
    name: "Farmer",
    grad: "from-[#06B6D4] to-[#67E8F9]",
    perks: ["Sell Produce", "Manage Deliveries", "Access Marketplace"],
  },
];

export const UserTypes = () => (
  <section id="community" data-testid="user-types-section" className="relative overflow-hidden py-24 sm:py-32">
    <div aria-hidden="true" className="absolute -left-40 top-1/3 h-[420px] w-[420px] rounded-full bg-[#635BFF]/10 blur-[150px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#00D26A]">
          Who It's For
        </p>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Pick your player. The OS adapts.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {TYPES.map((t, i) => (
          <Reveal key={t.name} delay={0.07 * i} className="h-full">
            <motion.div
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
              data-testid={`user-type-${t.name.toLowerCase().replace(" ", "-")}`}
              className="flex h-full flex-col rounded-3xl border border-white/10 bg-[#111827]/90 p-7 backdrop-blur-xl"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br ${t.grad}`}>
                <t.icon className="h-5 w-5 text-white" />
              </span>
              <h3 className="mt-5 font-display text-xl font-bold text-white">{t.name}</h3>
              <ul className="mt-5 space-y-3">
                {t.perks.map((p) => (
                  <li key={p} className="flex items-center gap-2.5 text-sm text-slate-300">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#00D26A]/15">
                      <Check className="h-3 w-3 text-[#00D26A]" />
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
